import { render, staticRenderFns } from "./r-map-kind-dialog.vue?vue&type=template&id=2bf3c8f4&scoped=true"
import script from "./r-map-kind-dialog.vue?vue&type=script&lang=js"
export * from "./r-map-kind-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-map-kind-dialog.vue?vue&type=style&index=0&id=2bf3c8f4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf3c8f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bf3c8f4')) {
      api.createRecord('2bf3c8f4', component.options)
    } else {
      api.reload('2bf3c8f4', component.options)
    }
    module.hot.accept("./r-map-kind-dialog.vue?vue&type=template&id=2bf3c8f4&scoped=true", function () {
      api.rerender('2bf3c8f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/map-kind/r-map-kind-dialog.vue"
export default component.exports